import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        app,
        user,
    },
    getters: {
        account: state => state.user.account,
        account_menus: state => state.user.account_menus,
        sidebar: state => state.app.sidebar,
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js